export interface BoundingBox {
  LeftTopY: number;
  RightBtmY: number;
  LeftTopX: number;
  RightBtmX: number;
}

export interface AlarmExtend {
  confidence?: number;
  quality?: number;
  trackId?: number;
  timestamp?: string;
  label?: number;
  evtUuid?: string;
  deviceSn?: string;
  rtspUuid?: string;
  k_TaskLUT?: string;
  bbox?: {
    height: number;
    left_x: number;
    top_y: number;
    width: number;
  };
  pitch?: number;
  roll?: number;
  yaw?: number;
  gender?: string;
  age_group?: string;
  age_max?: string;
  age_min?: string;
  pedestrian_angle?: string;
  pose?: string;
  cap_style?: string;
  cap_color?: string;
  coat_style?: string;
  coat_color?: string;
  coat_length?: string;
  coat_pattern?: string;
  trousers_color?: string;
  trousers_length?: string;
  trousers_pattern?: string;
  shoes_style?: string;
  shoes_color?: string;
  hair_style?: string;
  hair_color?: string;
  reflective_clothes?: string;
  respirator_v2?: string;
  glove_v2?: string;
  glass_style?: string;
  bag_style?: string;
  smoking?: string;
  fishing?: string;
  phone_status?: string;
  hold_object_in_front_v2?: string;
  oxygen_bottle?: string;
  gas_alarm?: string;
  umbrella?: string;
  umbrella_color?: string;
  uniform?: string;
  truck_specification?: string;
  truck_style?: string;
  automobile_angle?: string;
  danger_strip?: string;
  spare_tire?: string;
  cross_status?: string;
  [key: string]: unknown;
}

export interface AlarmItem {
  id: number;
  taskId: string;
  srcId: string;
  type: number;
  time: number;
  frameIndex: number;
  bigImage: string;
  smallImage: string;
  box: BoundingBox | null;
  Extend: string;
}

export interface AlarmListResult {
  items: AlarmItem[];
  maxSize: string;
  pageCount: number;
  pageNo: number;
  pageSize: number;
  total: number;
  usedSize: string;
}

export interface AlarmListResponse {
  code: number;
  msg: string;
  result: AlarmListResult;
}

export interface AttributeField {
  key: keyof AlarmExtend;
  label: string;
}

export const PERSON_ATTRIBUTE_FIELDS: AttributeField[] = [
  { key: "gender", label: "Gender" },
  { key: "age_group", label: "Age" },
  { key: "cap_style", label: "Cap" },
  { key: "coat_color", label: "Coat" },
  { key: "pose", label: "Pose" },
];
